var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.93,
    height: 12.201,
    viewBox: "0 0 5.93 12.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook",
    d: "M1.514,12.2V6.476H0V4.415H1.514V2.654A2.617,2.617,0,0,1,4.469,0,12.511,12.511,0,0,1,5.92.08L5.871,2.005S5.242,2,4.555,2c-.743,0-.862.342-.862.911V4.415H5.93l-.1,2.061H3.693V12.2H1.514"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6d284c9ff9ff3c392cd1383b81628192.svg";
export { ForwardRef as ReactComponent };